(function(){
  const products={
    graceful:{type:'lipstick',name:'I am Graceful',kicker:'Velvet Era Lipsticks',price:'₹999',old:'',shade:'Soft everyday nude',swatch:'#B97770',img:'assets/products/graceful-product-user.png',detail:'assets/catalog/graceful-2.png',model:'assets/catalog/graceful-3.png',gallery:[['Product','assets/products/graceful-product-user.png'],['Texture','assets/catalog/graceful-2.png'],['Model 1','assets/catalog/graceful-3.png'],['Model 2','assets/catalog/graceful-4.png'],['Model 3','assets/catalog/graceful-5.png']],desc:'A soft everyday nude with creamy glide, velvety matte comfort, and a polished finish that feels easy from morning to evening.'},
    powerful:{type:'lipstick',name:'I am Powerful',kicker:'Velvet Era Lipsticks',price:'₹999',old:'',shade:'Bold warm tone',swatch:'#A74648',img:'assets/products/velvet-lipstick-secondary.png',detail:'assets/catalog/powerful-2.png',model:'assets/catalog/powerful-3.png',gallery:[['Product','assets/products/velvet-lipstick-secondary.png'],['Texture','assets/catalog/powerful-2.png'],['Model 1','assets/catalog/powerful-3.png'],['Model 2','assets/catalog/powerful-4.png'],['Model 3','assets/catalog/powerful-5.png']],desc:'A confident warm lipstick shade made for days when your colour should lead the look without compromising comfort.'},
    rare:{type:'lipstick',name:'I am Rare',kicker:'Velvet Era Lipsticks',price:'₹999',old:'',shade:'Refined rose depth',swatch:'#A85C69',img:'assets/catalog/rare-1.png',detail:'assets/catalog/rare-2.png',model:'assets/catalog/rare-3.png',gallery:[['Product','assets/catalog/rare-1.png'],['Texture','assets/catalog/rare-2.png'],['Model 1','assets/catalog/rare-3.png'],['Model 2','assets/catalog/rare-4.png'],['Model 3','assets/catalog/rare-5.png']],desc:'A refined rose shade with quiet depth, made to look polished, soft, and expressive without feeling loud.'},
    timeless:{type:'lipstick',name:'I am Timeless',kicker:'Velvet Era Lipsticks',price:'₹999',old:'',shade:'Classic neutral',swatch:'#A5695D',img:'assets/catalog/timeless-1.png',detail:'assets/catalog/timeless-2.png',model:'assets/catalog/timeless-3.png',gallery:[['Product','assets/catalog/timeless-1.png'],['Texture','assets/catalog/timeless-2.png'],['Model 1','assets/catalog/timeless-3.png'],['Model 2','assets/catalog/timeless-4.png'],['Model 3','assets/catalog/timeless-5.png']],desc:'A classic neutral for polished days, clean looks, and effortless touch-ups with a balanced velvet finish.'},
    worthy:{type:'lipstick',name:'I am Worthy',kicker:'Velvet Era Lipsticks',price:'₹999',old:'',shade:'Soft berry nude',swatch:'#9B5262',img:'assets/catalog/worthy-1.png',detail:'assets/catalog/worthy-2.png',model:'assets/catalog/worthy-3.png',gallery:[['Product','assets/catalog/worthy-1.png'],['Texture','assets/catalog/worthy-2.png'],['Model 1','assets/catalog/worthy-3.png'],['Model 2','assets/catalog/worthy-4.png']],desc:'A graceful berry nude with romantic softness, smooth payoff, and a wearable matte veil.'},
    unstoppable:{type:'lipstick',name:'I am Unstoppable',kicker:'Velvet Era Lipsticks',price:'₹999',old:'',shade:'Statement velvet colour',swatch:'#873A43',img:'assets/products/unstoppable-product-user.png',detail:'assets/catalog/unstoppable-2.png',model:'assets/catalog/unstoppable-3.png',gallery:[['Product','assets/products/unstoppable-product-user.png'],['Texture','assets/catalog/unstoppable-2.png'],['Model 1','assets/catalog/unstoppable-3.png'],['Model 2','assets/catalog/unstoppable-4.png'],['Model 3','assets/catalog/unstoppable-5.png']],desc:'The statement shade of the Velvet Era family, created for high-impact colour with a soft, comfortable finish.'},
    glowup:{type:'blush',name:"It's Giving Glow Up",kicker:'Glow Era Blushes',price:'₹799',old:'',shade:'Fresh glow finish',swatch:'#dc8b83',img:'assets/catalog/glowup-1.png',detail:'assets/catalog/glowup-3.png',model:'assets/catalog/glowup-4.png',gallery:[['Product','assets/catalog/glowup-1.png'],['Product + Swatch','assets/catalog/glowup-2.png'],['Texture','assets/catalog/glowup-3.png'],['Model 1','assets/catalog/glowup-4.png'],['Model 2','assets/catalog/glowup-5.png'],['Model 3','assets/catalog/glowup-6.png']],desc:'A fresh, natural-looking flush with finely milled pigments that blend effortlessly into skin.'},
    goldenhour:{type:'blush',name:"It's Giving Grace",kicker:'Glow Era Blushes',price:'₹799',old:'',shade:'Soft graceful pink',swatch:'#d98aa2',img:'assets/catalog/grace-1.png',detail:'assets/catalog/grace-3.png',model:'assets/catalog/grace-4.png',gallery:[['Product','assets/catalog/grace-1.png'],['Product + Swatch','assets/catalog/grace-2.png'],['Texture','assets/catalog/grace-3.png'],['Model 1','assets/catalog/grace-4.png'],['Model 2','assets/catalog/grace-5.png'],['Model 3','assets/catalog/grace-6.png']],desc:'A graceful pink flush that brings delicate colour, soft luminosity, and an easy clean-beauty finish.'},
    rosebloom:{type:'blush',name:"It's Giving Power",kicker:'Glow Era Blushes',price:'₹799',old:'',shade:'Confident berry pink',swatch:'#d0527d',img:'assets/catalog/blushpower-1.png',detail:'assets/catalog/blushpower-3.png',model:'assets/catalog/blushpower-4.png',gallery:[['Product','assets/catalog/blushpower-1.png'],['Product + Swatch','assets/catalog/blushpower-2.png'],['Texture','assets/catalog/blushpower-3.png'],['Model 1','assets/catalog/blushpower-4.png'],['Model 2','assets/catalog/blushpower-5.png'],['Model 3','assets/catalog/blushpower-6.png']],desc:'A confident berry-pink blush that builds beautifully for a stronger cheek moment while staying soft on skin.'},
    sunkiss:{type:'blush',name:"It's Giving Sass",kicker:'Glow Era Blushes',price:'₹799',old:'',shade:'Playful rosy pop',swatch:'#c94473',img:'assets/catalog/sass-1.png',detail:'assets/catalog/sass-3.png',model:'assets/catalog/sass-4.png',gallery:[['Product','assets/catalog/sass-1.png'],['Product + Swatch','assets/catalog/sass-2.png'],['Texture','assets/catalog/sass-3.png'],['Model 1','assets/catalog/sass-4.png'],['Model 2','assets/catalog/sass-5.png'],['Model 3','assets/catalog/sass-6.png']],desc:'A playful rosy pop for expressive cheeks, blended with a smooth texture that keeps the finish polished.'},
    coralbliss:{type:'blush',name:"It's Giving Warmth",kicker:'Glow Era Blushes',price:'₹799',old:'',shade:'Warm terracotta glow',swatch:'#b96858',img:'assets/catalog/warmth-1.png',detail:'assets/catalog/warmth-3.png',model:'assets/catalog/warmth-4.png',gallery:[['Product','assets/catalog/warmth-1.png'],['Product + Swatch','assets/catalog/warmth-2.png'],['Texture','assets/catalog/warmth-3.png'],['Model 1','assets/catalog/warmth-4.png'],['Model 2','assets/catalog/warmth-5.png'],['Model 3','assets/catalog/warmth-6.png']],desc:'A warm terracotta glow that brightens the complexion with a sun-kissed, skin-like finish.'},
    bundle:{type:'bundle',name:'The Era Bundle',kicker:'Limited Offer',price:'₹1,599',old:'₹1,798',shade:'Choose any lipstick + blush shade',swatch:'#BB6765',img:'assets/products/bundle-combo-cap.png',detail:'assets/products/bundle-texture.jpg',model:'assets/catalog/pdf-source-1.jpg',gallery:[['Product','assets/products/bundle-combo-cap.png'],['Texture','assets/products/bundle-texture.jpg'],['Model 1','assets/catalog/pdf-source-1.jpg'],['Model 2','assets/catalog/pdf-source-2.jpg'],['Model 3','assets/catalog/pdf-source-3.jpg']],desc:'Choose any one Velvet Era Lipstick shade and any one Glow Era Blush shade at the bundle price.'},
    lipstickpack2:{type:'lipstickpack',name:'Velvet Era Lipsticks - Pack of 2',kicker:'Velvet Era Value Pack',price:'₹1,799',old:'₹1,998',shade:'Choose any 2 lipstick shades',swatch:'#A74648',img:'assets/products/velvet-lipstick-pack-2.png',detail:'assets/catalog/powerful-2.png',model:'assets/products/powerful-model.jpg',gallery:[['Product pair','assets/products/velvet-lipstick-pack-2.png'],['Shade swatch','assets/catalog/powerful-2.png'],['Model','assets/products/powerful-model.jpg']],desc:'Choose any two Velvet Era Lipstick shades and save with this curated value pack.'},
    blushpack2:{type:'blushpack',name:'Glow Era Blushes - Pack of 2',kicker:'Glow Era Value Pack',price:'₹1,399',old:'₹1,598',shade:'Choose any 2 blush shades',swatch:'#D98AA2',img:'assets/products/glow-era-blush-pack-2-user.png',detail:'assets/catalog/glowup-2.png',model:'assets/products/grace-model.jpg',gallery:[['Product pair','assets/products/glow-era-blush-pack-2-user.png'],['Shade swatch','assets/catalog/glowup-2.png'],['Model','assets/products/grace-model.jpg']],desc:'Choose any two Glow Era Blush shades and save with this curated value pack.'}
  };
  const lipstickKeys=['graceful','powerful','rare','timeless','worthy','unstoppable'];
  const blushKeys=['glowup','goldenhour','rosebloom','sunkiss','coralbliss'];
  const lipstickPackScale={graceful:1.03,powerful:1,rare:1,timeless:1,worthy:1,unstoppable:1.11};
  const fallbackImages={
    lipstick:'assets/product-lipstick.svg',
    blush:'assets/product-blush.svg',
    bundle:'assets/product-bundle.svg',
    lipstickpack:'assets/product-lipstick.svg',
    blushpack:'assets/product-blush.svg',
    model:'assets/model-look.svg'
  };
  const reviewPool=[
    {name:'Sanya Wadhwa',date:'06/11/2026',initial:'S',rating:5,verified:false,photos:['assets/reviews/sanya-wadhwa-1.jpg'],text:'Tried the Vikar Beauty blush in the shade Power and I’m obsessed! 😍✨\n\nThe shade gives such a beautiful natural flush, blends easily, and looks super flattering on the skin. Perfect for everyday makeup as well as full glam. 💕\n\nDefinitely a new favorite in my makeup bag! 🌸'},
    {name:'Manjika Bhatt',date:'05/01/2026',initial:'M',rating:5,verified:true,photos:['assets/reviews/manjika-bhatt-1.jpg','assets/reviews/manjika-bhatt-2.jpg','assets/reviews/manjika-bhatt-3.jpg'],text:"The texture is a dream, it has a gorgeous, near-velvet finish that's perfect for oily/acne-prone skin, giving a glow without the grease (and it looks so good on camera too).\nAlso, a little really goes a long way as it is so pigmented!!\nI'm already looking forward to using it for a seamless monochromatic look on my cheeks, eyelids, and lips."},
    {name:'Muskan Verma',date:'05/01/2026',initial:'M',rating:5,verified:false,photos:['assets/reviews/muskan-verma-1.jpg'],text:'Absolutely beautiful productss!!\nThe blush gives a fresh, natural flush, and the lipstick has amazing pigmentation with a super comfortable wear that doesn’t dry out my lips. The clean, minimal-girl aesthetic packaging is just the cherry on top🩷💄\nA promising start 🤌🏻 Can’t wait to try more shades!!!'},
    {name:'Himanshi',date:'04/24/2026',initial:'H',rating:5,verified:false,photos:['assets/reviews/himanshi-1.jpg','assets/reviews/himanshi-2.jpg','assets/reviews/himanshi-3.jpg','assets/reviews/himanshi-4.jpg'],text:'BEST BLUSH EVER!!!\n\nI ordered ITS GIVING GRACE and ITS GIVING WARMTH and I kid you not, I don’t think I am ever using any other blush forever!! Thank you so much for the beautiful shades Vikar. You made my day✨☺️'}
  ];
  const lipstickIngredients=`
    <p><strong>Vitamin E:</strong> Helps condition the lips and support long-lasting comfort.</p>
    <p><strong>Vitamin C:</strong> Helps keep lips feeling smooth and cared for while wearing matte colour.</p>
    <p><strong>Full ingredient list:</strong> Synthetic Wax, Cyclopentasiloxane, Hydrogenated Polycyclopentadiene, Isododecane, Methyl Methacrylate Crosspolymer, Trimethylsiloxysilicate, Isodododecane, Talc (and) Methicone, CI 77491, Dimethicone (and) Dimethicone/Vinyl, Copernicia Cerifera Cera, Euphorbia Seed Cera, Rhus Verniciflua Peel Cera, Annuus Seed Oil, Cera Alba, Ecoserene Synthetic Wax, Isononyl Isononanoate, CI 77891, Isohexadecane, Polybutene, Aluminum Starch Octenylsuccinate, CI 77492, CI 77499, CI 15880:1, CI 15850:1, Caprylyl Methicone, CI 15850, Euphorbia Cerifera Cera, Cera Microcristallina (and), Pentaerythrityl Tetra-di-t-butyl, Ascorbyl Tetraisopalmitate, Tocopheryl Acetate.</p>`;
  const blushIngredients=`
    <p><strong>Hyaluronic Acid:</strong> Helps attract and retain moisture, keeping the skin feeling comfortable and hydrated throughout wear.</p>
    <p><strong>Vitamin E:</strong> An antioxidant that helps condition the skin and support overall skin comfort.</p>
    <p><strong>Full ingredient list:</strong> Isopropyl Myristate, Dimethicone, Cyclopentasiloxane, Hydrogenated Polyisobutene, Ethylhexyl Palmitate, Polybutene, Cyclopentasiloxane (and) Dimethiconol, Octyldodecanol, Caprylic/Capric Triglyceride, Polyglyceryl-4 Isostearate, Silica, CI 77491, CI 77891, CI 45410, Copernicia Cerifera Cera, Cera Microcristallina (and) Hydrogenated Vegetable Oil (and) Stearyl Stearate (and) Stearic Acid, Cellulose, Disteardimonium Hectorite, Hydrogenated Microcrystalline Wax, Propylene Carbonate, CI 19140, Glyceryl Behenate Eicosadioate, Pentaerythrityl Tetra-di-t-butyl Hydroxyhydrocinnamate, Sodium Hyaluronate, Tocopheryl Acetate, Phenoxyethanol, Ethylhexylglycerin, CI 77499, CI 15880, Fragrance, CI 120850.</p>`;
  const lipstickLove=['Creamy application that sets into a velvety matte finish','Transfer-resistant once set','Rich colour payoff with a smooth, even feel','Lightweight and comfortable for everyday wear','Designed to wear evenly without feeling heavy','Vegan','Cruelty-Free','Paraben-Free','Mineral Oil Free','No harsh chemicals','Perfect for everyday use','Made in India'];
  const blushLove=['Smooth, creamy texture that blends effortlessly','Buildable colour with a natural, skin-like finish','Lightweight and comfortable for everyday wear','Designed to feel gentle and breathable on skin','Easy to apply and wears well throughout the day','Vegan','Cruelty-Free','Paraben-Free','Mineral Oil Free','No harsh chemicals','Perfect for everyday use','Made in India'];
  const productCopy={
    lipstick:{
      size:'3.2 GMS',
      badges:['Cruelty free','Infused with Vitamin E','Vegan','Infused with Vitamin C','Paraben free'],
      intro:'A creamy velvet matte lipstick created for rich colour payoff, comfort, and a soft-focus finish that feels smooth through the day.',
      description:item=>`${item.name} is part of the Vikar Beauty Velvet Era Lipsticks range: a comfortable matte lipstick designed for Indian skin tones, everyday confidence, and expressive colour. Its creamy texture glides on smoothly, settles into a velvety finish, and keeps lips looking polished without feeling heavy.`,
      apply:'Apply directly from the bullet for full colour payoff, or tap onto the lips with your finger for a softer stained effect. Let it set for a few moments for the most comfortable velvet finish.',
      ingredients:lipstickIngredients,
      love:lipstickLove
    },
    blush:{
      size:'6.0 ML',
      badges:['Cruelty free','Infused with Hyaluronic Acid','Vegan','Infused with Vitamin E','Non comedogenic'],
      intro:'A soft flush that feels effortless and looks like your skin.',
      description:item=>`The Vikar Beauty Glow Era Blush is a smooth, skin-melting cream blush designed to add natural-looking colour with comfort. Its creamy texture glides on easily, blends seamlessly, and settles into a soft, skin-like finish that feels lightweight throughout the day. Created to balance performance with everyday wearability, this blush is buildable and blendable, allowing you to go from a sheer, fresh flush to a more defined look without feeling heavy or greasy. Available in five thoughtfully curated shades, designed to complement Indian skin tones beautifully.`,
      apply:'Dot a small amount on the apples of your cheeks and blend upward with fingertips, a brush, or a sponge. Add another light layer for a brighter flush.',
      ingredients:blushIngredients,
      love:blushLove
    },
    bundle:{
      size:'1 lipstick + 1 blush',
      badges:['Cruelty free','Vegan','Vitamin enriched','Bundle & save','Everyday duo'],
      intro:'The only duo your makeup bag needs.',
      description:item=>`${item.name} brings the Velvet Era Lipstick and Glow Era Blush together for a complete soft-glam routine. It pairs comfortable lip colour with a fresh cheek flush, giving you a polished look that still feels easy and wearable.`,
      apply:'Apply the blush first for a fresh base of colour, then finish with your Velvet Era Lipstick. Build both products slowly until the look feels like your era.',
      ingredients:`<h4>Velvet Era Lipstick</h4>${lipstickIngredients}<h4>Glow Era Blush</h4>${blushIngredients}`,
      love:blushLove
    }
  };
  productCopy.lipstickpack={...productCopy.lipstick,size:'2 × 3.2 GMS',intro:'Choose any two Velvet Era Lipstick shades in one value pack.',description:item=>`${item.name} lets you build a two-shade Velvet Era wardrobe while keeping the same creamy glide, rich colour payoff, and comfortable velvety matte finish.`};
  productCopy.blushpack={...productCopy.blush,size:'2 × 6.0 ML',intro:'Choose any two Glow Era Blush shades in one value pack.',description:item=>`${item.name} lets you pair two buildable Glow Era shades for an effortless, skin-like flush with lightweight everyday comfort.`};
  const shopifyData=window.vikarCurrentShopifyProduct||null;
  const shopifyDescriptor=String(`${shopifyData?.handle||''} ${shopifyData?.title||''} ${shopifyData?.type||''}`).toLowerCase();
  const shopifyIsBlush=shopifyDescriptor.includes('blush');
  function keyFromText(value){
    const text=String(value||'').toLowerCase().replace(/[^a-z0-9]+/g,' ');
    if(text.includes('pack of 2')&&text.includes('blush')) return 'blushpack2';
    if(text.includes('pack of 2')&&(text.includes('lipstick')||text.includes('velvet'))) return 'lipstickpack2';
    if(text.includes('bundle')||text.includes('combo')) return 'bundle';
    if(text.includes('unstoppable')) return 'unstoppable';
    if(text.includes('powerful')||text.includes('i am power')) return 'powerful';
    if(text.includes('worthy')) return 'worthy';
    if(text.includes('timeless')) return 'timeless';
    if(text.includes('rare')) return 'rare';
    if(text.includes('graceful')) return 'graceful';
    if(text.includes('giving warmth')||text.includes('coral bliss')) return 'coralbliss';
    if(text.includes('giving sass')||text.includes('sun kiss')) return 'sunkiss';
    if(text.includes('giving power')||text.includes('rose bloom')) return 'rosebloom';
    if(text.includes('giving grace')||text.includes('golden hour')) return 'goldenhour';
    if(text.includes('giving glowing up')) return 'glowup';
    if(text.includes('giving up')) return 'goldenhour';
    if(text.includes('glow up')) return 'glowup';
    if(shopifyIsBlush&&/(^| )warmth( |$)/.test(text)) return 'coralbliss';
    if(shopifyIsBlush&&/(^| )sass( |$)/.test(text)) return 'sunkiss';
    if(shopifyIsBlush&&/(^| )power( |$)/.test(text)) return 'rosebloom';
    if(shopifyIsBlush&&/(^| )grace( |$)/.test(text)) return 'goldenhour';
    if(text.includes('blush')) return 'glowup';
    if(text.includes('lipstick')||text.includes('velvet')) return 'graceful';
    return '';
  }
  function variantMatchesKeys(variant,requiredKeys){
    if(!requiredKeys.length) return false;
    const options=(variant.options?.length?variant.options:String(variant.title||'').split('/')).map(keyFromText);
    return requiredKeys.every((key,index)=>options[index]===key);
  }
  const selectedShopifyVariant=shopifyData?.variants?.find(variant=>String(variant.id)===String(shopifyData.selectedVariantId))||shopifyData?.variants?.find(variant=>variant.available)||shopifyData?.variants?.[0];
  const variantByKey={};
  (shopifyData?.variants||[]).forEach(variant=>{
    const key=keyFromText(variant.title);
    if(key&&!variantByKey[key]) variantByKey[key]=variant;
    if(key&&products[key]) Object.assign(products[key],{price:variant.price,old:variant.compareAtPrice||products[key].old,variantId:variant.id,available:variant.available});
  });
  const inferredKey=keyFromText(`${shopifyData?.handle||''} ${shopifyData?.title||''} ${selectedShopifyVariant?.title||''}`);
  const fallbackKey=new URLSearchParams(window.location.search).get('vikar');
  const slug=inferredKey||fallbackKey||document.body.dataset.product||'graceful';
  if(shopifyData&&products[slug]&&selectedShopifyVariant){
    Object.assign(products[slug],{price:selectedShopifyVariant.price,old:selectedShopifyVariant.compareAtPrice||products[slug].old,variantId:selectedShopifyVariant.id,available:selectedShopifyVariant.available,desc:shopifyData.description||products[slug].desc});
  }
  function isShadeSpecificMedia(label){return /^(product|texture|swatch|shade)/i.test(label||'')}
  function uniqueGallery(items){
    const seen=new Set();
    return items.filter(item=>{
      const src=item?.[1];
      if(!src || seen.has(src)) return false;
      seen.add(src);
      return true;
    });
  }
  const sharedLipstickGallery=uniqueGallery((products.graceful.gallery||[]).filter(item=>!isShadeSpecificMedia(item[0])));
  let activeKey=slug;
  let product=products[activeKey]||products.graceful;
  let activeView='Product';
  let qty=1;
  let reviewFilter='all';
  let reviewSort='recent';
  let activePhotoIndex=0;
  const main=document.querySelector('[data-main-image]');
  const heroFrame=main?.closest('.hero-frame');
  const thumbs=document.querySelector('[data-thumbs]');
  function productUrl(key){
    const variant=variantByKey[key];
    if(variant&&shopifyData?.url) return `${shopifyData.url}?variant=${variant.id}`;
    const mapped=window.vikarShopify?.productUrls?.[key];
    if(mapped) return mapped;
    if(key==='bundle') return 'product-era-bundle.html';
    if(key==='lipstickpack2') return 'product-lipstick-pack-2.html';
    if(key==='blushpack2') return 'product-blush-pack-2.html';
    return `product-${key}.html`;
  }
  function safeText(selector,value){
    const node=document.querySelector(selector);
    if(node) node.textContent=value;
  }
  function safeHtml(selector,value){
    const node=document.querySelector(selector);
    if(node) node.innerHTML=value;
  }
  function fallbackFor(item){return fallbackImages[item.type]||fallbackImages.lipstick}
  function imageTag(src,alt,extra=''){
    return `<img src="${src}" alt="${alt}" ${extra} onerror="this.onerror=null;this.src='${fallbackFor(product)}'">`;
  }
  function selectedBundleKeys(){
    return {
      lipstick:document.querySelector('[data-bundle-lipstick]')?.value || 'graceful',
      blush:document.querySelector('[data-bundle-blush]')?.value || 'glowup'
    };
  }
  function selectedBundleGallery(item){
    const selected=selectedBundleKeys();
    const lipstick=products[selected.lipstick]||products.graceful;
    const blush=products[selected.blush]||products.glowup;
    const sharedLipstickMedia=sharedLipstickGallery.map(([label,src])=>[`${label} · Lipstick`,src]);
    return uniqueGallery([
      ['Product pair',item.img],
      ['Product · Lipstick',lipstick.img],
      ['Swatch · Lipstick',lipstick.detail],
      ...sharedLipstickMedia,
      ['Product · Blush',blush.img],
      ['Swatch · Blush',blush.detail],
      ['Model · Blush',blush.model]
    ]);
  }
  function selectedPackGallery(item){
    const isLipstickPack=item.type==='lipstickpack';
    const defaults=isLipstickPack?['graceful','powerful']:['glowup','goldenhour'];
    const selected=[...document.querySelectorAll('[data-pack-choice]')].map(select=>select.value);
    const keys=[selected[0]||defaults[0],selected[1]||defaults[1]];
    const gallery=[['Product pair',item.img]];
    keys.forEach((key,index)=>{
      const shade=products[key]||products[defaults[index]];
      const shadeGallery=shade.gallery||[['Product',shade.img],['Texture',shade.detail],['Model 1',shade.model]];
      const slot=index+1;
      shadeGallery.forEach(([label,src])=>{
        if(/^(texture|swatch|shade|product \+ swatch)/i.test(label||'')){
          gallery.push([`Swatch · Shade ${slot}`,src]);
        }else if(/^model/i.test(label||'')){
          gallery.push([`${label} · Shade ${slot}`,src]);
        }
      });
    });
    return uniqueGallery(gallery);
  }
  function productGallery(item){
    if(item.type==='bundle') return selectedBundleGallery(item);
    if(item.type==='lipstickpack' || item.type==='blushpack') return selectedPackGallery(item);
    const gallery=item.gallery||[['Product',item.img],['Texture',item.detail],['Model 1',item.model]];
    return uniqueGallery(gallery);
  }
  function moneyToNumber(price){return Number((price||'').replace(/[^\d]/g,'')||0)}
  function activeCopy(){return productCopy[product.type]||productCopy.lipstick}
  function primaryReviewPhoto(review){return review.photos?.[0]||product.model||product.img}
  function starString(rating){return '★'.repeat(rating)+'☆'.repeat(5-rating)}
  function escapeHtml(value){return String(value).replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]))}
  function paragraphHtml(value){return escapeHtml(value).split(/\n{2,}/).map(part=>`<p>${part.replace(/\n/g,'<br>')}</p>`).join('')}
  function selectedBundleText(){
    if(product.type==='lipstickpack'){
      const choices=[...document.querySelectorAll('[data-pack-choice]')].map(select=>products[select.value]?.name||select.value);
      return `Lipsticks: ${choices.join(' · ')}`;
    }
    if(product.type==='blushpack'){
      const choices=[...document.querySelectorAll('[data-pack-choice]')].map(select=>products[select.value]?.name||select.value);
      return `Blushes: ${choices.join(' · ')}`;
    }
    const lipKey=document.querySelector('[data-bundle-lipstick]')?.value || 'graceful';
    const blushKey=document.querySelector('[data-bundle-blush]')?.value || 'glowup';
    return `Lipstick: ${products[lipKey]?.name||lipKey} · Blush: ${products[blushKey]?.name||blushKey}`;
  }
  function setProductDataset(button){
    if(!button) return;
    const gallery=productGallery(product);
    const selectedImage=gallery.find(item=>item[0]===activeView)||gallery[0];
    button.dataset.productName=product.name;
    button.dataset.productPrice=product.price;
    button.dataset.productImage=selectedImage?.[1]||product.img;
    button.dataset.productDesc=['bundle','lipstickpack','blushpack'].includes(product.type) ? `${product.desc} ${selectedBundleText()}` : product.desc;
    button.dataset.productQty=qty;
    const selectedBundle=selectedBundleKeys();
    const requiredKeys=product.type==='bundle'?[selectedBundle.blush,selectedBundle.lipstick]:['lipstickpack','blushpack'].includes(product.type)?[...document.querySelectorAll('[data-pack-choice]')].map(select=>select.value):[];
    const chosenVariant=(shopifyData?.variants||[]).find(variant=>variantMatchesKeys(variant,requiredKeys))||variantByKey[activeKey]||selectedShopifyVariant;
    if(chosenVariant){
      button.dataset.variantId=chosenVariant.id;
      button.dataset.available=String(chosenVariant.available);
      button.disabled=!chosenVariant.available;
      button.setAttribute('aria-disabled',String(!chosenVariant.available));
    }
    const properties={};
    if(product.type==='bundle'){
      const selected=selectedBundleKeys();properties['Lipstick shade']=products[selected.lipstick]?.name||selected.lipstick;properties['Blush shade']=products[selected.blush]?.name||selected.blush;
    }else if(product.type==='lipstickpack'||product.type==='blushpack'){
      [...document.querySelectorAll('[data-pack-choice]')].forEach((select,index)=>{properties[`Shade ${index+1}`]=products[select.value]?.name||select.value});
    }
    button.dataset.productProperties=JSON.stringify(properties);
    const form=button.closest('form')||document.querySelector('[data-product-form]');
    const idInput=form?.querySelector('[data-product-variant-input]');
    const qtyInput=form?.querySelector('[data-product-quantity-input]');
    if(idInput&&chosenVariant) idInput.value=chosenVariant.id;
    if(qtyInput) qtyInput.value=qty;
  }
  function ensureBundleOptions(){
    const row=document.querySelector('.buy-row');
    if(!row || document.querySelector('[data-bundle-options]')) return;
    const lipstickOptions=lipstickKeys.map(key=>`<option value="${key}">${products[key].name}</option>`).join('');
    const blushOptions=blushKeys.map(key=>`<option value="${key}">${products[key].name}</option>`).join('');
    const lipstickOptionsSecond=lipstickKeys.map((key,index)=>`<option value="${key}" ${index===1?'selected':''}>${products[key].name}</option>`).join('');
    const blushOptionsSecond=blushKeys.map((key,index)=>`<option value="${key}" ${index===1?'selected':''}>${products[key].name}</option>`).join('');
    const isLipstickPack=product.type==='lipstickpack';
    const isBlushPack=product.type==='blushpack';
    const title=isLipstickPack?'Choose your 2 lipstick shades':isBlushPack?'Choose your 2 blush shades':'Choose your bundle shades';
    const controls=isLipstickPack
      ? `<label><span>Velvet Era Lipstick 1</span><select data-pack-choice>${lipstickOptions}</select></label><label><span>Velvet Era Lipstick 2</span><select data-pack-choice>${lipstickOptionsSecond}</select></label>`
      : isBlushPack
        ? `<label><span>Glow Era Blush 1</span><select data-pack-choice>${blushOptions}</select></label><label><span>Glow Era Blush 2</span><select data-pack-choice>${blushOptionsSecond}</select></label>`
        : `<label><span>Velvet Era Lipstick</span><select data-bundle-lipstick>${lipstickOptions}</select></label><label><span>Glow Era Blush</span><select data-bundle-blush>${blushOptions}</select></label>`;
    row.insertAdjacentHTML('beforebegin',`
      <div class="bundle-options" data-bundle-options hidden>
        <p class="option-label">${title}</p>
        <div class="bundle-option-grid">
          ${controls}
        </div>
      </div>
    `);
  }
  function ensureBuyNow(){
    const row=document.querySelector('.buy-row');
    if(row && !row.querySelector('[data-buy-now]')){
      row.insertAdjacentHTML('beforeend','<button class="buy-now cart-add-trigger" type="button" data-add data-buy-now>Buy It Now</button>');
    }
  }
  function updatePackPreview(){
    const preview=document.querySelector('[data-pack-preview]');
    if(!preview || !['bundle','lipstickpack','blushpack'].includes(product.type)) return;
    if(product.type==='bundle'){
      const selected=selectedBundleKeys();
      const keys=[selected.lipstick,selected.blush];
      preview.querySelectorAll('img').forEach((image,index)=>{
        const item=products[keys[index]] || (index===0?products.graceful:products.glowup);
        image.src=item.img;
        image.alt=item.name;
      });
      return;
    }
    const defaults=product.type==='lipstickpack'?['graceful','powerful']:['glowup','goldenhour'];
    const selected=[...document.querySelectorAll('[data-pack-choice]')].map(select=>select.value);
    const keys=[selected[0]||defaults[0],selected[1]||defaults[1]];
    preview.querySelectorAll('img').forEach((image,index)=>{
      const key=keys[index];
      const item=products[key]||products[defaults[index]];
      image.src=item.img;
      image.alt=item.name;
      image.style.setProperty('--pack-image-scale',product.type==='lipstickpack'?(lipstickPackScale[key]||1):1);
    });
  }
  function ensureDetails(){
    if(document.querySelector('[data-product-details]')) return;
    document.querySelector('.ritual')?.insertAdjacentHTML('beforebegin',`
      <section class="product-details" data-product-details>
        <div class="product-detail-card">
          <div class="pd-item open" data-detail-item>
            <button type="button" class="pd-title" data-detail-toggle><span>→</span> Product Description <em>−</em></button>
            <div class="pd-content" data-detail-description></div>
          </div>
          <div class="pd-item" data-detail-item>
            <button type="button" class="pd-title" data-detail-toggle><span>→</span> How to Apply <em>+</em></button>
            <div class="pd-content" data-detail-apply></div>
          </div>
          <div class="pd-item" data-detail-item>
            <button type="button" class="pd-title" data-detail-toggle><span>→</span> Ingredients <em>+</em></button>
            <div class="pd-content" data-detail-ingredients></div>
          </div>
          <div class="pd-item" data-detail-item>
            <button type="button" class="pd-title" data-detail-toggle><span>→</span> Why You'll Love It <em>+</em></button>
            <div class="pd-content" data-detail-love></div>
          </div>
        </div>
      </section>
    `);
  }
  function ensureStickyBar(){
    if(document.querySelector('[data-sticky-buy]')) return;
    document.body.insertAdjacentHTML('beforeend',`
      <div class="sticky-buy" data-sticky-buy>
        <img data-sticky-img alt="">
        <div class="sticky-info">
          <strong data-sticky-title></strong>
          <span data-sticky-shade></span>
        </div>
        <span class="sticky-price" data-sticky-price></span>
        <button type="button" class="sticky-add cart-add-trigger" data-add>+ Add to Cart</button>
      </div>
    `);
  }
  function ensureReviews(){
    if(document.querySelector('[data-reviews]')) return;
    document.querySelector('.related')?.insertAdjacentHTML('beforebegin',`
      <section class="reviews" data-reviews>
        <div class="review-head">
          <div>
            <p class="review-kicker">Customer Reviews</p>
            <h2><span data-review-score>5.0</span> <em data-review-count>4 reviews</em></h2>
          </div>
          <button type="button" class="write-review" data-open-review>Write a review</button>
        </div>
        <div class="review-photos" data-review-photos></div>
        <div class="review-tabs">
          <button type="button" class="active">Product reviews (4)</button>
          <button type="button">Store reviews (1)</button>
        </div>
        <div class="review-tools">
          <button type="button" class="review-filter-toggle" data-toggle-filters aria-expanded="false">Filter</button>
          <select class="review-sort" data-review-sort aria-label="Sort reviews">
            <option value="recent">Most recent</option>
            <option value="highest">Highest rating</option>
            <option value="lowest">Lowest rating</option>
            <option value="pictures">Pictures first</option>
          </select>
        </div>
        <div class="review-filters" data-review-filters hidden>
          <button type="button" data-review-filter="all" class="active">All</button>
          <button type="button" data-review-filter="5">5 ★</button>
          <button type="button" data-review-filter="pictures">With pictures</button>
          <button type="button" data-review-filter="verified">Verified</button>
        </div>
        <div class="review-grid"></div>
      </section>
    `);
  }
  function ensureReviewModal(){
    if(document.querySelector('[data-review-modal]')) return;
    document.body.insertAdjacentHTML('beforeend',`
      <div class="review-modal" data-review-modal aria-hidden="true">
        <div class="review-dialog" role="dialog" aria-modal="true" aria-label="Write a review">
          <button type="button" class="review-close" data-close-review aria-label="Close review">×</button>
          <div class="review-step is-active" data-review-step="rating">
            <h2>How would you rate this product?</h2>
            <p>We would love it if you would share a bit about your experience.</p>
            <img class="review-product-img" data-modal-img alt="">
            <h3 data-modal-title></h3>
            <div class="review-stars-input" data-review-stars></div>
            <div class="rating-labels"><span>Poor</span><span>Great</span></div>
          </div>
          <div class="review-step" data-review-step="content">
            <h3 data-modal-title-two></h3>
            <div class="review-stars-input compact" data-review-stars-two></div>
            <label class="review-label" for="reviewText">Review content (Required)</label>
            <textarea id="reviewText" data-review-text placeholder="Start writing here..."></textarea>
            <p class="review-terms">We'll only contact you about your review if necessary. By submitting your review, you agree to our <u>terms and conditions</u> and <u>privacy policy</u>.</p>
            <div class="review-actions"><button type="button" data-review-back>← Back</button><button type="button" data-review-post>Next</button></div>
          </div>
        </div>
      </div>
    `);
  }
  function ensurePhotoReviewModal(){
    if(document.querySelector('[data-photo-review-modal]')) return;
    document.body.insertAdjacentHTML('beforeend',`
      <div class="photo-review-modal" data-photo-review-modal aria-hidden="true">
        <div class="photo-review-dialog" role="dialog" aria-modal="true" aria-label="Customer review photo">
          <button type="button" class="photo-review-close" data-close-photo-review aria-label="Close photo review">×</button>
          <div class="photo-review-media">
            <button type="button" class="photo-nav prev" data-photo-prev aria-label="Previous photo">‹</button>
            <img src="${product.img}" data-photo-review-img alt="">
            <button type="button" class="photo-nav next" data-photo-next aria-label="Next photo">›</button>
            <div class="photo-review-thumbs" data-photo-review-thumbs></div>
          </div>
          <div class="photo-review-copy">
            <div class="review-stars" data-photo-review-stars>★★★★★</div>
            <div class="review-author"><span data-photo-review-initial></span><div><strong data-photo-review-name></strong><small><span data-photo-review-date></span> <em data-photo-review-verified></em></small></div></div>
            <div data-photo-review-text></div>
          </div>
        </div>
      </div>
    `);
  }
  function setMain(src,alt,view='Product'){
    activeView=view;
    if(heroFrame) heroFrame.dataset.view=view;
    main.classList.add('switching');
    setTimeout(()=>{
      main.onerror=()=>{main.onerror=null;main.src=fallbackFor(product)};
      main.dataset.view=view;
      main.dataset.kind=product.type;
      main.src=src;
      main.alt=alt;
      main.onload=()=>main.classList.remove('switching');
    },120);
  }
  function paint(){
    ensureBuyNow();
    ensureBundleOptions();
    ensureDetails();
    ensureStickyBar();
    ensureReviews();
    ensureReviewModal();
    ensurePhotoReviewModal();
    document.title=`${product.name} | Vikar Beauty`;
    document.querySelectorAll('[data-kicker]').forEach(item=>item.textContent=product.kicker);
    safeHtml('[data-title]',product.name.replace('I am ','I am <em>')+(product.name.startsWith('I am ')?'</em>':''));
    safeText('[data-shade]',product.type==='bundle'?selectedBundleText():product.shade);
    safeText('[data-price]',product.price);
    safeText('[data-old]',product.old);
    safeText('[data-desc]',product.desc);
    const bundleOptions=document.querySelector('[data-bundle-options]');
    if(bundleOptions) bundleOptions.hidden=!['bundle','lipstickpack','blushpack'].includes(product.type);
    const addButton=document.querySelector('[data-add]');
    addButton.textContent=`Add to Cart - ${product.price}`;
    document.querySelectorAll('[data-add]').forEach(setProductDataset);
    main.onerror=()=>{main.onerror=null;main.src=fallbackFor(product)};
    const gallery=productGallery(product);
    const selectedImage=gallery.find(item=>item[0]===activeView)||gallery[0];
    activeView=selectedImage[0];
    if(heroFrame) heroFrame.dataset.view=activeView;
    main.dataset.view=activeView;
    main.dataset.kind=product.type;
    main.src=selectedImage[1]; main.alt=`${product.name} ${activeView}`;
    updatePackPreview();
    thumbs.innerHTML=gallery.map(item=>`<button class="thumb ${item[0]===activeView?'active':''}" type="button" data-img="${item[1]}" data-view="${item[0]}" aria-label="${item[0]}">${imageTag(item[1],`${product.name} ${item[0]}`)}</button>`).join('');
    const shadeKeys=product.type==='blush'?blushKeys:product.type==='lipstick'?lipstickKeys:product.type==='bundle'?['bundle']:[];
    safeHtml('[data-swatches]',shadeKeys.map(key=>`<a class="swatch ${key===activeKey?'active':''}" href="${productUrl(key)}" data-product-key="${key}" style="background:${products[key].swatch}" aria-label="${products[key].name}" aria-current="${key===activeKey?'true':'false'}"></a>`).join(''));
    safeHtml('[data-shades]',shadeKeys.map(key=>`<a class="shade-chip ${key===activeKey?'active':''}" href="${productUrl(key)}" data-product-key="${key}" aria-current="${key===activeKey?'true':'false'}">${products[key].name}</a>`).join(''));
    const relatedKeys=[...lipstickKeys,...blushKeys,'bundle'].filter(key=>key!==activeKey);
    const runningKeys=[...relatedKeys,...relatedKeys];
    safeHtml('[data-related]',runningKeys.map(key=>`<a class="rel-card" href="${productUrl(key)}"><img src="${products[key].img}" alt="${products[key].name}" onerror="this.onerror=null;this.src='${fallbackFor(products[key])}'"><div><h3>${products[key].name}</h3><p>${products[key].price}</p></div></a>`).join(''));
    const copy=activeCopy();
    safeHtml('[data-detail-description]',`<p><strong>Size:</strong> ${copy.size}</p><p>${copy.intro}</p><p>${copy.description(product)}</p>`);
    safeHtml('[data-detail-apply]',`<p>${copy.apply}</p>`);
    safeHtml('[data-detail-ingredients]',copy.ingredients);
    safeHtml('[data-detail-love]',`<ul>${copy.love.map(item=>`<li>${item}</li>`).join('')}</ul>`);
    document.querySelector('.benefit-row').innerHTML=copy.badges.map(label=>`<span class="benefit"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20 6L9 17l-5-5"/></svg>${label}</span>`).join('');
    renderReviewPhotos();
    renderReviews();
    safeText('[data-sticky-title]',product.kicker);
    safeText('[data-sticky-shade]',product.name);
    safeText('[data-sticky-price]',product.price);
    const stickyImg=document.querySelector('[data-sticky-img]');
    if(stickyImg){stickyImg.src=selectedImage[1];stickyImg.alt=`${product.name} ${activeView}`}
    const modalImg=document.querySelector('[data-modal-img]');
    if(modalImg){modalImg.src=selectedImage[1];modalImg.alt=`${product.name} ${activeView}`}
    safeText('[data-modal-title]',product.kicker);
    safeText('[data-modal-title-two]',product.kicker);
    renderReviewStars(0);
    document.querySelectorAll('[data-add]').forEach(setProductDataset);
    initRelatedScroller();
  }
  function selectShade(key,{updateHistory=true}={}){
    const nextProduct=products[key];
    if(!nextProduct || key===activeKey) return;
    if(updateHistory&&shopifyData&&!variantByKey[key]){window.location.href=productUrl(key);return}
    activeKey=key;
    product=nextProduct;
    qty=1;
    const qtyValue=document.querySelector('[data-qty-value]');
    if(qtyValue) qtyValue.textContent=qty;
    paint();
    if(updateHistory && window.history?.pushState) window.history.pushState({vikarProductKey:key},'',productUrl(key));
  }
  function flattenedPhotos(){
    return reviewPool.flatMap((review,reviewIndex)=>review.photos.map((photo,photoIndex)=>({review,reviewIndex,photo,photoIndex})));
  }
  function filteredReviews(){
    let list=[...reviewPool];
    if(reviewFilter==='pictures') list=list.filter(review=>review.photos.length);
    else if(reviewFilter==='verified') list=list.filter(review=>review.verified);
    else if(reviewFilter!=='all') list=list.filter(review=>String(review.rating)===reviewFilter);
    if(reviewSort==='highest') list.sort((a,b)=>b.rating-a.rating);
    if(reviewSort==='lowest') list.sort((a,b)=>a.rating-b.rating);
    if(reviewSort==='pictures') list.sort((a,b)=>b.photos.length-a.photos.length);
    return list;
  }
  function renderReviewPhotos(){
    const photos=flattenedPhotos();
    safeHtml('[data-review-photos]',photos.map((item,index)=>`
      <button type="button" class="review-photo-btn" data-review-photo="${index}" aria-label="Open ${item.review.name} review photo">
        <img src="${item.photo}" alt="${item.review.name} review photo" onerror="this.closest('button').style.display='none'">
      </button>
    `).join(''));
  }
  function renderReviews(){
    const list=filteredReviews();
    safeHtml('.review-grid',list.map((review)=>{
      const photoIndex=flattenedPhotos().findIndex(item=>item.review===review);
      return `
        <article class="review-card">
          <div class="review-stars">${starString(review.rating)}</div>
          <div class="review-author"><span>${review.initial}</span><div><strong>${review.name}</strong><small>${review.date}${review.verified?' · Verified':''}</small></div></div>
          <div class="review-body">${paragraphHtml(review.text)}</div>
          ${review.photos.length?`<button type="button" class="review-photo-large" data-review-photo="${photoIndex}"><img src="${primaryReviewPhoto(review)}" alt="${review.name} review photo"></button>`:''}
        </article>
      `;
    }).join(''));
  }
  function renderReviewStars(active=0){
    document.querySelectorAll('[data-review-stars],[data-review-stars-two]').forEach(group=>{
      group.innerHTML=[1,2,3,4,5].map(value=>`<button type="button" class="${value<=active?'active':''}" data-rate="${value}" aria-label="${value} stars">★</button>`).join('');
    });
  }
  function openReviewModal(){
    const modal=document.querySelector('[data-review-modal]');
    if(!modal) return;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('review-locked');
    showReviewStep('rating');
    renderReviewStars(0);
  }
  function closeReviewModal(){
    const modal=document.querySelector('[data-review-modal]');
    if(!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('review-locked');
  }
  function showReviewStep(step){
    document.querySelectorAll('[data-review-step]').forEach(item=>item.classList.toggle('is-active',item.dataset.reviewStep===step));
  }
  function addPostedReview(text,rating){
    reviewPool.unshift({name:'Your Review',date:'Just now',initial:'Y',rating,verified:false,photos:[],text});
    renderReviewPhotos();
    renderReviews();
  }
  function openPhotoReview(index){
    const items=flattenedPhotos();
    const item=items[index];
    const modal=document.querySelector('[data-photo-review-modal]');
    if(!item || !modal) return;
    activePhotoIndex=index;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('review-locked');
    safeText('[data-photo-review-name]',item.review.name);
    safeText('[data-photo-review-initial]',item.review.initial);
    safeText('[data-photo-review-date]',item.review.date);
    safeText('[data-photo-review-verified]',item.review.verified?'Verified':'');
    safeText('[data-photo-review-stars]',starString(item.review.rating));
    safeHtml('[data-photo-review-text]',paragraphHtml(item.review.text));
    const image=document.querySelector('[data-photo-review-img]');
    if(image){image.src=item.photo;image.alt=`${item.review.name} review photo`}
    safeHtml('[data-photo-review-thumbs]',items.map((thumb,thumbIndex)=>`
      <button type="button" class="${thumbIndex===index?'active':''}" data-review-photo="${thumbIndex}">
        <img src="${thumb.photo}" alt="${thumb.review.name} thumbnail">
      </button>
    `).join(''));
  }
  function closePhotoReview(){
    const modal=document.querySelector('[data-photo-review-modal]');
    if(!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('review-locked');
  }
  function movePhotoReview(direction){
    const photos=flattenedPhotos();
    if(!photos.length) return;
    openPhotoReview((activePhotoIndex+direction+photos.length)%photos.length);
  }
  function initRelatedScroller(){
    const rail=document.querySelector('[data-related]');
    if(!rail || rail.dataset.ready==='true') return;
    rail.dataset.ready='true';
    let isDown=false;
    let startX=0;
    let startScroll=0;
    let holdUntil=0;
    const speed=.36;
    const half=()=>rail.scrollWidth/2;
    const pause=(ms=900)=>{holdUntil=Date.now()+ms};
    rail.scrollLeft=0;
    rail.addEventListener('pointerdown',event=>{
      isDown=true;
      startX=event.clientX;
      startScroll=rail.scrollLeft;
      rail.classList.add('is-dragging');
      pause(1400);
    });
    rail.addEventListener('pointermove',event=>{
      if(!isDown) return;
      rail.scrollLeft=startScroll-(event.clientX-startX);
      pause(500);
    });
    ['pointerup','pointercancel','pointerleave'].forEach(type=>{
      rail.addEventListener(type,()=>{
        if(!isDown) return;
        isDown=false;
        rail.classList.remove('is-dragging');
        pause(650);
      });
    });
    rail.addEventListener('wheel',()=>pause(1200),{passive:true});
    const tick=()=>{
      if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches && Date.now()>holdUntil){
        rail.scrollLeft+=speed;
        const midpoint=half();
        if(midpoint && rail.scrollLeft>=midpoint) rail.scrollLeft-=midpoint;
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
  paint();
  document.addEventListener('click',event=>{
    const shadeLink=event.target.closest('[data-product-key]');
    if(shadeLink){
      event.preventDefault();
      selectShade(shadeLink.dataset.productKey);
      return;
    }
    const thumb=event.target.closest('.thumb');
    if(thumb){
      document.querySelectorAll('.thumb').forEach(item=>item.classList.remove('active'));
      thumb.classList.add('active');
      setMain(thumb.dataset.img,product.name,thumb.dataset.view);
    }
    const q=event.target.closest('[data-qty]');
    if(q){
      qty=Math.max(1,qty+Number(q.dataset.qty));
      document.querySelector('[data-qty-value]').textContent=qty;
      document.querySelectorAll('[data-add]').forEach(setProductDataset);
    }
    const add=event.target.closest('[data-add]');
    if(add){
      document.querySelectorAll('[data-add]').forEach(setProductDataset);
    }
    const toggle=event.target.closest('[data-detail-toggle]');
    if(toggle){
      const item=toggle.closest('[data-detail-item]');
      const open=item.classList.toggle('open');
      toggle.querySelector('em').textContent=open?'−':'+';
    }
    if(event.target.closest('[data-open-review]')) openReviewModal();
    if(event.target.closest('[data-close-review]') || event.target===document.querySelector('[data-review-modal]')) closeReviewModal();
    if(event.target.closest('[data-close-photo-review]') || event.target===document.querySelector('[data-photo-review-modal]')) closePhotoReview();
    if(event.target.closest('[data-photo-prev]')) movePhotoReview(-1);
    if(event.target.closest('[data-photo-next]')) movePhotoReview(1);
    const photo=event.target.closest('[data-review-photo]');
    if(photo) openPhotoReview(Number(photo.dataset.reviewPhoto));
    const filterToggle=event.target.closest('[data-toggle-filters]');
    if(filterToggle){
      const panel=document.querySelector('[data-review-filters]');
      const isOpen=panel.hasAttribute('hidden');
      panel.toggleAttribute('hidden',!isOpen);
      filterToggle.setAttribute('aria-expanded',String(isOpen));
    }
    const reviewFilterButton=event.target.closest('[data-review-filter]');
    if(reviewFilterButton){
      reviewFilter=reviewFilterButton.dataset.reviewFilter;
      document.querySelectorAll('[data-review-filter]').forEach(item=>item.classList.toggle('active',item===reviewFilterButton));
      renderReviews();
    }
    const rate=event.target.closest('[data-rate]');
    if(rate){
      window.vikarReviewRating=Number(rate.dataset.rate);
      renderReviewStars(window.vikarReviewRating);
      window.setTimeout(()=>showReviewStep('content'),180);
    }
    if(event.target.closest('[data-review-back]')) showReviewStep('rating');
    if(event.target.closest('[data-review-post]')){
      const text=document.querySelector('[data-review-text]').value.trim();
      if(!text){
        document.querySelector('[data-review-text]').classList.add('needs-review');
        return;
      }
      addPostedReview(text,window.vikarReviewRating||5);
      document.querySelector('[data-review-text]').value='';
      closeReviewModal();
    }
  });
  document.addEventListener('change',event=>{
    const bundleSelect=event.target.closest('[data-bundle-lipstick],[data-bundle-blush],[data-pack-choice]');
    if(bundleSelect){
      if(product.type==='bundle'){
        if(bundleSelect.matches('[data-bundle-lipstick]')){
          if(!activeView.endsWith('· Lipstick') || isShadeSpecificMedia(activeView)) activeView='Product pair';
        }else if(bundleSelect.matches('[data-bundle-blush]')){
          if(activeView!=='Model · Blush') activeView='Product pair';
        }
        paint();
      }else{
        paint();
      }
      document.querySelectorAll('[data-add]').forEach(setProductDataset);
    }
    const sort=event.target.closest('[data-review-sort]');
    if(sort){
      reviewSort=sort.value;
      renderReviews();
    }
  });
  window.addEventListener('popstate',event=>{
    const key=event.state?.vikarProductKey || document.body.dataset.product;
    if(products[key]) selectShade(key,{updateHistory:false});
  });
})();
